<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">

        <b-button block v-b-toggle.term-section-6
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">06</span>
                  <span>Transactions and Limits</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
        </b-button>

      </b-card-header>
      <b-collapse
        id="term-section-6"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Transaction limits, daily limits, and any other restrictions on card
            use will be provided at the time of issuance and may vary based on
            your account status and jurisdiction.
          </p>
          <p class="text-justify">
            You may not exceed the available balance on your card for any
            transaction. If your card has insufficient funds, the transaction
            will be declined.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "term-5",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
